import { convertDateESTToUTCToUserLocal } from '../../utilz/dates';
import { DEFAULT_STORE_OBJECT } from '../constants';
import POShipmentDraftSearchType from './POShipmentDraftSearchTypes';

const initialState = {
  shipmentInfoList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
    totalCount: 0,
  },
  shipmentInfoListReq: {
    customerKey: 0,
    vendorKey: 0,
    carrierKey: 0,
    poNumber: '',
    shipmentNo: '',
    createdOnFrom: '',
    createdOnTo: '',
    shipmentType: 'Draft',
    pageIndex: 0,
    pageSize: 10,
    orderByColumn: '',
    orderBySort: '',
  },
  shipmentSearchExportVisible: false,
  shipmentDraftSearchExportData: {
    data: [],
  },
  isSelectedAllItems: false,
};

// biome-ignore lint/style/useDefaultParameterLast: <explanation>
const POShipmentDraftSearchReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case POShipmentDraftSearchType.SET_SHIPMENT_DRAFT_SEARCH_EXPORT_TOGGLE: {
      return {
        ...state,
        shipmentSearchExportVisible: payload.show || false,
        shipmentDraftSearchExportData: {
          data: payload.data,
        },
      };
    }
    case POShipmentDraftSearchType.GET_SHIPMENT_DRAFT_INFO_LIST: {
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentInfoList,
          progressing: true,
        },
      };
    }

    case POShipmentDraftSearchType.GET_SHIPMENT_DRAFT_INFO_LIST_SUCCESS: {
      payload.data?.item2.forEach((element) => {
        element.isChecked = state.isSelectedAllItems || false;
        element.expShipDate = convertDateESTToUTCToUserLocal(element.expShipDate);
        element.expDeliveryDate = convertDateESTToUTCToUserLocal(element.expDeliveryDate);
        element.shipmentDate = convertDateESTToUTCToUserLocal(element.shipmentDate);
        element.createdOn = convertDateESTToUTCToUserLocal(element.createdOn);
      });
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentInfoList,
          success: true,
          totalCount: payload.data?.item1?.totalCount,
          data: [...state.shipmentInfoList.data, ...(payload?.data?.item2 ?? [])],
          progressing: false,
        },
      };
    }

    case POShipmentDraftSearchType.GET_SHIPMENT_DRAFT_INFO_LIST_FAIL: {
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.shipmentInfoList,
          error: true,
          success: false,
          progressing: false,
        },
      };
    }

    case POShipmentDraftSearchType.GET_SHIPMENT_DRAFT_INFO_LIST_RESET: {
      return {
        ...state,
        shipmentInfoList: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          totalCount: 0,
        },
      };
    }

    case POShipmentDraftSearchType.UPDATE_SHIPMENT_DRAFT_INFO_LIST_CHECKED_ITEMS: {
      const temp = [];

      state.shipmentInfoList.data.forEach((item) => {
        if (payload === true || payload === false) {
          item.isChecked = payload;
        } else {
          if (payload.shipmentKey === item.shipmentKey) {
            item.isChecked = !item.isChecked;
          }
        }

        temp.push(item);
      });

      const findSelectedItem = state.shipmentInfoList.data.filter((item) => item.isChecked === true);

      return {
        ...state,
        isSelectedAllItems: findSelectedItem.length === state.shipmentInfoList.data.length,
        shipmentInfoList: {
          ...state.shipmentInfoList,
          data: temp,
        },
      };
    }

    case POShipmentDraftSearchType.UPDATE_SHIPMENT_DRAFT_INFO_LIST_REQUEST: {
      return {
        ...state,
        shipmentInfoListReq: {
          ...state.shipmentInfoListReq,
          ...payload,
        },
      };
    }

    default:
      return state;
  }
};

export default POShipmentDraftSearchReducer;
